import React, {Component} from "react";
import {connect} from "react-redux";
import {Button, Col, Form, Row} from "react-bootstrap";
import Modal from "react-responsive-modal";
import {FIRMWARE_TYPE, BUILD_TYPE} from '../constants/Constants';

const strings = require('../resources/strings.json');

export default class GoldenBuildModal extends Component {

    state = {
      selectedBuildType: "",
      selectedBuild: "",
      buildDialogErrors: []
    }

    constructor(props) {
        super(props);
        this.validateForms = this.validateForms.bind(this);
        this.onSelectBuildType = this.onSelectBuildType.bind(this);
        this.onSelectBuild = this.onSelectBuild.bind(this);
        this.getBuildType = this.getBuildType.bind(this);
        this.getBuildVersion = this.getBuildVersion.bind(this);
    }

    async componentDidUpdate(prevProps) {
        if(((prevProps.buildList !== null) && this.props.buildList.length !== prevProps.buildList.length)) {
            this.setState({
                buildDialogErrors: [null,null]
            })
        }
    }

    async validateForms() {
        let errors = [null, null];
        if(this.state.selectedBuildType == "") {
            errors[0] = "Select a build type"
        }

        if(this.state.selectedBuild == "") {
            errors[1] = "Select a build"
        }

        for (let i = 0; i < errors.length; i++) {
            if (errors[i] !== null) {
                this.setState({buildDialogErrors: errors});
                return
            }
        }

        await this.props.updateGoldenBuild(this.state.selectedBuildType, this.state.selectedBuild);
        this.props.onCloseClicked();
    }
   

    onSelectBuildType = function (event) {
        this.setState({selectedBuildType: event.target.value});
    };

    onSelectBuild = function (event) {
        this.setState({selectedBuild: event.target.value});
    };

    getBuildType = function (buildType) {
        switch(buildType) {
            case BUILD_TYPE.SWITCH_FIRMWARE_BUILD: return FIRMWARE_TYPE.SWITCH_DEVICE_IMAGE;
            case BUILD_TYPE.SWITCH_IMAGE_BUILD: return FIRMWARE_TYPE.SWITCH_STM_IMAGE;
            case BUILD_TYPE.PAC_FIRMWARE_BUILD: return FIRMWARE_TYPE.AC_DEVICE_IMAGE;
            case BUILD_TYPE.PAC_IMAGE_BUILD: return FIRMWARE_TYPE.PCB_IMAGE;
        }
    };

    getBuildVersion = function (build) {
        return build.major+"."+build.minor+"."+build.revision;
    };

    render() {
        return (
            <Modal open={this.props.show} onClose={this.props.onCloseClicked}>
                <h4 style={{width: "700px"}}>{strings.updateGoldenBuild}</h4>
                <hr/>
                <Row>
                    <Form>
                        <Form.Group controlId="upgradeForm.ControlInput1">
                            <Col sm={1}>
                                <div style={{marginTop: 4}}>
                                    Type:
                                </div>
                            </Col>
                            <Col sm={4}>
                                <select className="form-control" value={this.state.selectedBuildType}
                                        onChange={this.onSelectBuildType}>
                                    <option value="">{strings.selectType}</option>
                                    <option value={BUILD_TYPE.SWITCH_FIRMWARE_BUILD}>{strings.switchFirmwareBuild}</option>
                                    <option value={BUILD_TYPE.SWITCH_IMAGE_BUILD}>{strings.switchImageBuild}</option>
                                    <option value={BUILD_TYPE.PAC_FIRMWARE_BUILD}>{strings.pacFirmwareBuild}</option>
                                </select>
                            </Col>
                        </Form.Group>
                    </Form>
                </Row>
                <Row>
                    <Form>
                        <Form.Group controlId="upgradeForm.ControlInput1">
                            <Col sm={1}>
                                <div style={{marginTop: 4}}>
                                    Build:
                                </div>
                            </Col>
                            <Col sm={4}>
                                <select className="form-control" value={this.state.selectedBuild}
                                        onChange={this.onSelectBuild}>
                                    <option value="">{strings.selectBuild}</option>
                                    {
                                        (this.props.buildList !== null) 
                                        ?
                                         this.props.buildList.filter(e => e.firmwareType == this.getBuildType(this.state.selectedBuildType)).map((e, key) => {
                                            return <option key={key} value={e.buildUrl}>{this.getBuildVersion(e)}</option>;
                                        })
                                        :
                                        null
                                    }
                                </select>
                            </Col>
                        </Form.Group>
                    </Form>
                </Row>
                <Row>
                    <Col sm={12}>
                    <Button variant="primary" style={{margin: 20}}
                                onClick={this.validateForms}>{strings.submit}</Button>
                    </Col>
                </Row>
            </Modal>
        )
    }
}
